import React from 'react';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';
import {
  NumberOfItemsInTable,
  NumberOfItemsInTableProps,
} from 'src/components/enterprise/Parents/NumberOfItemsInTable/NumberOfItemsInTable';

export type NumberOfChildAccountsProps = Omit<
  NumberOfItemsInTableProps,
  'suffix'
>;

export const NumberOfChildAccounts: React.FC<NumberOfChildAccountsProps> = ({
  totalResults,
  ...props
}) => {
  const noun = getSingularOrPlural(totalResults, 'account');

  const suffix = `child ${noun}`;

  return (
    <NumberOfItemsInTable
      {...props}
      totalResults={totalResults}
      suffix={suffix}
    />
  );
};
